import React, { useEffect, useState } from "react";
import {
  fill_heart,
  grp_member1,
  grp_member2,
  grp_member3,
  grp_member4,
  grp_member5,
  heart_icon,
  lock_icon,
  subscription_icon,
} from "../../../../assets";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { getTimeDifference } from "../../../../utils/dateTimeFormat";
import { charLimit } from "../../../../utils/commonHelper";
import InfiniteScroll from "react-infinite-scroll-component";
import { GoDotFill } from "react-icons/go";
import { updateFavoriteListHandler } from "./LikeUnlikeHeart";
// import SkeletonLoader from "../../../../shimmer/Shimmer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { GroupCardSkeleton } from "../../../../shimmer/groups/GroupsListingShimmer";

const MyGroup = ({ groupList, fetchMoreData, hasMore, setGroupList }) => {
  //----------here-check-more-than-one-category---to-check-level-wise-------------
  const getParentCategories = (group) => {
    if (!group || typeof group !== "object" || !group._parent) return [];

    let categories = [];
    let currentParent = group._parent;

    while (currentParent && typeof currentParent === "object") {
      if (currentParent.categoryName) {
        categories.unshift(currentParent.categoryName);
      }
      currentParent = currentParent._parent || null;
    }

    return categories.length > 0 ? categories : [];
  };

  return (
    <>
      <div className="CategoriesGroupsList_parent">
        <div id="scrollableContainer" className="CategoriesGroupsList_cards">
          <InfiniteScroll
            dataLength={groupList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<GroupCardSkeleton count={5} />}
            endMessage={
              <p style={{ textAlign: "center", margin: "25px" }}>
                <b>No more data to display</b>
              </p>
            }
            scrollableTarget="scrollableContainer"
          >
            <div className="health_hub_cards">
              {groupList && groupList?.length > 0
                ? groupList?.map((data, ind) => (
                    <div key={data?._id + ind} className="health_hub_img">
                      <Link
                        to={`/dashboard/group/detail/${data?._group?._id}`}
                      ></Link>
                      <div className="image_containerss pointer-cursor">
                        <img src={data?._group?.coverImage} />
                        <div className="health_hub_img_text">
                          <h6>{data?._group?.name}</h6>
                          <p>
                            {data?._group?.newFeeds?.count > 0 ? (
                              <>
                                <GoDotFill className="live_dot" />
                                {`${data?._group?.newFeeds?.count} New Post${
                                  data?._group?.newFeeds?.count > 1 ? "s" : ""
                                }`}
                              </>
                            ) : null}
                          </p>
                        </div>
                      </div>

                      <div className="health_hub_containt">
                        {/* Check if showGroupTag is enabled and display parent categories */}

                        <div className="badge_grp_wrap">
                        {data?._group?.settings?.showGroupTag &&
                          getParentCategories(data?._group).map(
                            (category, index) => (
                              <span key={index} className="badge_grp health">
                                {category}
                              </span>
                            )
                          )}
                          <span>{data?._group?.categoryName}</span>
                          </div>

                        

                        <figure className="health_hub_icons">
                          {data?._group?.type === "SUBSCRIPTION" && (
                            <img src={subscription_icon} className="lockimg" />
                          )}
                          {data?._group?.type === "PRIVATE" && (
                            <img src={lock_icon} className="lockimg" />
                          )}
                          <img
                            src={
                              data?.favoriteGroup?.status === "ACTIVE"
                                ? fill_heart
                                : heart_icon
                            }
                            className="heartimg"
                            onClick={() =>
                              updateFavoriteListHandler(
                                data?._group?._id,
                                setGroupList,
                                data?.favoriteGroup?.status === "ACTIVE"
                                  ? "INACTIVE"
                                  : "ACTIVE"
                              )
                            }
                          />
                        </figure>

                      </div>
                    </div>
                  ))
                : null}
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </>
  );
};

export default MyGroup;
